import { MutableRefObject, useRef } from 'react';

import { NwCollegePredictorServiceTypes } from '../../services/NwCollegePredictorServices/APIService';
import { NwCollegePredictorService } from '../../services/NwCollegePredictorServices/APIService/index.api';
import { networkCallWithApisauceWithHeaders } from '../../utils/AuthAPIUtils';

import { useCollegePredictorRefreshAuthTokens } from '../useCollegePredictorRefreshAuthTokens';

const useNwCollegePredictorService = () => {
  const { refreshTokenApi, getAccessToken, getRefreshToken } =
    useCollegePredictorRefreshAuthTokens();

  const NwCollegePredictorServiceService: MutableRefObject<NwCollegePredictorServiceTypes | null> =
    useRef(null);

  if (NwCollegePredictorServiceService.current === null) {
    NwCollegePredictorServiceService.current = new NwCollegePredictorService(
      networkCallWithApisauceWithHeaders({
        refreshAuthTokensAPI: refreshTokenApi,
        getAccessToken,
        getRefreshToken
      })
    );
  }

  return {
    nwCollegePredictorServiceService: NwCollegePredictorServiceService.current
  };
};

export { useNwCollegePredictorService };
